import { Button, Menu } from '@mantine/core';
import { useGeneratePersona } from '../hooks/useGeneratePersona';

export const GeneratePersonaButton = () => {
    const { generate } = useGeneratePersona();

    return (
        <Menu withinPortal>
            <Menu.Target>
                <Button>Generate Persona</Button>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item onClick={() => generate(1)}>Generate 1</Menu.Item>
                <Menu.Item onClick={() => generate(2)}>Generate 2</Menu.Item>
                <Menu.Item onClick={() => generate(3)}>Generate 3</Menu.Item>
                <Menu.Item onClick={() => generate(5)}>Generate 5</Menu.Item>
                <Menu.Item onClick={() => generate(10)}>Generate 10</Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};
